import useSetCoachIdByPathState from 'src/features/Calendar/hooks/useSetCoachIdByPathState';
import PersonalScheduleDetail from 'src/features/PersonalScheduleDetail';

export function PersonalScheduleDetailPage() {
  useSetCoachIdByPathState();
  return <PersonalScheduleDetail />;
}
